import throttle from 'lodash.throttle'
import debounce from 'lodash.debounce'
import CountUp from 'countup.js'

export default class ScrollTrack {
  constructor(selector = '[data-scroll-track]', activeClass = 'play-scene'){
    this.trackers = Array.from(document.querySelectorAll(selector))
    this.activeClass = activeClass
    this.bodyEl = document.querySelector('body')

    this.buildTrackerObj()
    this.events()

    window.addEventListener('load', ()=>{
      // console.log('document load');
      // this.buildTrackerObj()
      this.scrollEvent()
    })

    // Disabled until scrolling at start bug fixed
  }

  events() {
    this.scrollEventHandler = throttle(this.scrollEvent, 100).bind(this)
    this.reinitValuesHandler = debounce(this.reinitValues, 100).bind(this)

    window.addEventListener('scroll', this.scrollEventHandler)
    window.addEventListener('resize', this.reinitValuesHandler)
  }

  buildTrackerObj(){
    this.trackerObj = {}

    this.trackers.forEach(el => {
      // const elRect = el.getBoundingClientRect()
      // this.trackerObj[Math.floor(elRect.top)] = el
      const offsetTop = el.offsetTop;
      const trackObj = {};
      trackObj['element'] = el;

      if (el.hasAttribute('data-scroll-counter')){
        trackObj['counter'] = this.setupCounter(el);
      }

      this.trackerObj[Math.floor(offsetTop)] = trackObj;
    })
    // console.log(this.trackerObj);
  }

  reinitValues() {
    this.buildTrackerObj()
  }

  scrollEvent() {
    const scrolled = this.bodyEl.scrollTop || document.documentElement.scrollTop

    // console.log('scrollEvent: ', scrolled);
    this.checkTrackers(scrolled)
  }

  setupCounter(el) {
    const counter = el.querySelector('[data-scroll-counter-target]')
    const endNumber = counter.getAttribute('data-scroll-counter-target')

    let counterOpts = {
      useEasing : true,
      useGrouping : true,
      separator : ','
    }
    counterOpts.suffix = counter.textContent.includes('%') ? '%' : '';

    const counterObj = new CountUp(counter, 0, endNumber, 0, 1, counterOpts);

    return counterObj;
  }

  checkTrackers(scrolled) {
    let threshold = (scrolled + Math.floor((window.innerHeight / 1.5)))

    for (var key in this.trackerObj) {

      // console.log('checkTracker:', scrolled, key, this.trackerObj[key]);

      if (threshold > key && this.trackerObj.hasOwnProperty(key)) {
        const element = this.trackerObj[key]['element'];

        if (this.trackerObj[key]['counter']){
          this.trackerObj[key]['counter'].start();
        }
        element.classList.add(this.activeClass);
        // Kill that obj as it's used
        delete this.trackerObj[key]
      }

    }
  }
}